import { getBrowser } from '../../react/utils/Platform';

export const CAPTCHA_URL =
  'https://www.clarovideo.com/scripts/captcha/captcha.php?sid=';
export const URL_MICROFWK = 'url_dominio_microfwk';
export const DEFAULT_ERROR_CODE = 'UNHANDLED_ERROR';
export const SSO_PLACEHOLDER_ERRORS = 'sso_placeholder_errors';
export const NOT_SUPPORT_REGION = 'Region no soportada';
export const ERROR_TRY_AGAIN = 'Lo sentimos hubo un error, intente nuevamente';
export const UNEXPECTED_ERROR = 'Ha Ocurrido un error inesperado';
export const CLOSE = 'Cerrar';
export const SSO_LOGIN = 'sso_inicia_sesion_text';
export const SSO_SELECT_OPTION_LABEL = 'sso_select_option_label';

export const rest = {
  device_id: 'web',
  device_category: 'web',
  device_model: 'web',
  device_type: 'web',
  device_so: getBrowser(),
  format: 'json',
  device_manufacturer: 'generic',
};

export const STEPS = {
  LANDING: 0,
  EMAIL_FORM: 1,
  PASSWORD_FORM: 2,
};

export const SUBMIT_TYPES = {
  previous: 'previous',
  next: 'next',
  terms: 'terms',
  promotion: 'promotion',
  email: 'email',
  validateEmail: 'validateEmail',
  cancel: 'cancel',
  submit: 'submit',
  done: 'done',
};

export const initialState = {
  region: '',
  modalIsOpen: false,
  loading: false,
  startHeaderInfo: {
    loading: false,
    model: null,
    error: false,
  },
  metadata: {
    loading: false,
    model: null,
    error: false,
  },
  assets: {
    loading: false,
    model: null,
    error: false,
  },
  config: {
    loading: false,
    model: null,
    error: false,
  },
  pinCodeSent: false,
  pinModal: { show: false },
  forms: [],
  formsController: {
    email: {},
    password: {},
    msisdn: {},
    otp: {},
  },
  failModal: {
    msg: '',
    show: false,
  },
};

const apiParamsDefault = {
  "device_id": "web",
  "device_category": "web",
  "device_manufacturer": "generic",
  "device_model": "web",
  "device_type": "web",
  "api_version": "v5.93",
  "authpn": "webclient",
  "authpt": "tfg1h3j4k6fd7",
  "format": "json",
  "HKS": "",
}

const shiApi = 'http://apa-api-web.clarovideo.net/';

export const REQUEST_DATA = {
  params: apiParamsDefault,
  endPoint: shiApi,
  HKS: '',
}

export const DEFAULT_LOGO = 'https://clarovideocdn5-a.akamaihd.net/pregeneracion//cms/apa/531eed34tvfy7b73a818a234/claro_logo_loading_xdk.png'
